<template>
  <div class="flat__plan plan">
    <img
      :style="{
        backgroundImage: 'url(' + planImage.image_thumb + ')',
      }"
      :class="[
        'cursor-zoom',
        {
          'plan-stub': planImage.stub,
        },
      ]"
      :src="planImage.source"
      width="560"
      height="560"
      loading="lazy"
      alt="Планировка"
      @click.prevent="openPopup"
    />

    <!-- <div v-if="hasDiscount" class="plan__discount">
      <span>{{ discount }}%</span>
      <small>СКИДКА</small>
    </div> -->

    <PlanDiscountLabel :data="flat" class="plan__discount" />

    <span v-if="planImage.stub" class="plan__text">
      Актуальная планировка будет добавлена в ближайшее время
    </span>

    <div v-if="hasDesignProject" class="plan__near near"></div>

    <div role="button" class="plan__zoom-button" @click.prevent="openPopup">
      <svg
        width="42"
        height="42"
        viewBox="0 0 42 42"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16 16L1 1M1 1H13.3529M1 1L1 12.4706"
          stroke="#FF0020"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M26 26L41 41M41 41H28.6471M41 41L41 29.5294"
          stroke="#FF0020"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  </div>
</template>

<script>
import PlanDiscountLabel from "@/components/PlanDiscountLabel.vue";
export default {
  name: "FlatPlan",
  components: {
    PlanDiscountLabel,
  },
  props: {
    planImage: {
      type: Object,
      required: true,
      validator: (value) => {
        return value && typeof value.source === "string";
      },
    },
    flat: {
      type: Object,
      required: true,
    },
    filters: {
      type: Object,
      required: true,
    },
  },
  computed: {
    hasDiscount() {
      return this.flat.discount;
    },
    hasGiveMeters() {
      return this.flat.properties?.give_meters;
    },
    discount() {
      return this.flat.discount;
    },
    discountArea() {
      return this.filters.squareFormat(this.filters.discountArea(this.flat));
    },
    hasDesignProject() {
      return this.flat.properties?.with_design_project;
    },
    popupTitle() {
      return this.flat.title
        ? this.flat.title
        : this.filters.flatNameNormalize(this.flat.layout) +
            ", №" +
            this.flat.number;
    },
  },
  methods: {
    openPopup() {
      this.$vfm.show({
        component: "PopupGallery",
        bind: {
          title: this.popupTitle,
          img: [{ src: this.planImage.source }],
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.plan {
  position: relative;
  margin-top: -20px;
  padding-bottom: 100%;

  > img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: auto;
    background-size: cover;

    &.plan-stub {
      opacity: 0.08;
      pointer-events: none;
    }
  }

  &__discount {
    position: absolute;
    top: 30px;
    right: 70px;
  }

  &__text {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 378px;
    font-weight: 400;
    font-size: 20px;
    text-align: center;
    transform: translate(-50%, -50%);
  }

  &__zoom-button {
    position: absolute;
    right: -30px;
    bottom: 30px;
    z-index: 10;
    width: max-content;

    &:hover {
      cursor: pointer;
    }
  }

  @media (max-width: 1280px) {
    &__discount {
      right: 50px;
    }
  }

  @media (max-width: 767px) {
    &__text {
      width: 269px;
      font-size: 18px;
    }
  }

  @media (max-width: 575px) {
    &__zoom-button {
      position: absolute;
      right: 0;
      bottom: 20px;
      z-index: 10;
      width: max-content;
    }

    &__discount {
      right: 10px;
    }
  }
}
</style>
